import { $ } from "@/common/Axios";

export default {
  /**
   * 班级课表
   */
  classCourseTable_clear: {
    /*
     * 清空实时课表
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/resource/classCourseTable/clear", p, c),
  },
  classCourseTable_init: {
    /*
     * 初始化
     * batch 批次 (string query required)
     * siteIds 学校id (array query )
     * siteType 学校类型：继教院 (string query required)
     * term 学期 (integer query required)
     */
    post: (p, c) => $.post("/api/cms/resource/classCourseTable/init", p, c),
  },
  classCourseTable_initByDomain: {
    /*
     * 初始化-根据学校域名
     * batch 批次 (string query required)
     * siteType 学校类型：继教院 (string query required)
     * term 学期 (integer query required)
     */
    post: (p, c) =>
      $.post("/api/cms/resource/classCourseTable/initByDomain", p, c),
  },
  classCourseTable_listForContinue: {
    /*
     * 继教院班级课表列表
     */
    get: (p, c) =>
      $.get("/api/cms/resource/classCourseTable/listForContinue", p, c),
  },
  classCourseTable_listForContinueByDomain: {
    /*
     * 继教院班级课表列表-根据学校域名
     */
    get: (p, c) =>
      $.get("/api/cms/resource/classCourseTable/listForContinueByDomain", p, c),
  },

  /**
   * 继教院教学计划
   */
  continueTeachingPlan: {
    /*
     * 添加
     * classHour 总课时 (integer query )
     * classRoomId 班级id (integer query )
     * courseId 课程id (integer query )
     * endTime 结束时间 (string query )
     * id  (integer query )
     * name 名称 (string query )
     * siteId 学校id (integer query )
     * startTime 开始时间 (string query )
     * teacherId 老师id (integer query )
     * term 学期 (integer query )
     * timeRange 时间 (string query )
     * type 类型 (string query )
     * weekClassHour 周课时 (integer query )
     */
    post: (p, c) => $.post("/api/cms/resource/continueTeachingPlan", p, c),

    /*
     * 删除
     * ids ids (array query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/continueTeachingPlan", p, c),
  },
  continueTeachingPlan_exportForClassRoom: {
    /*
     * 导出（班级教学计划）
     */
    get: (p, c) =>
      $.get("/api/cms/resource/continueTeachingPlan/exportForClassRoom", p, c),
  },
  continueTeachingPlan_exportForClassRoomByDomain: {
    /*
     * 导出（班级教学计划）-根据学校域名
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/continueTeachingPlan/exportForClassRoomByDomain",
        p,
        c
      ),
  },
  continueTeachingPlan_exportForSite: {
    /*
     * 导出（学校教学计划）
     */
    get: (p, c) =>
      $.get("/api/cms/resource/continueTeachingPlan/exportForSite", p, c),
  },
  continueTeachingPlan_listByClassRoomAndTerm: {
    /*
     * 根据班级和学期获取简易列表表（班级）
     * classRoomId 班级id (integer query required)
     * term 学期 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/continueTeachingPlan/listByClassRoomAndTerm",
        p,
        c
      ),
  },
  continueTeachingPlan_listForClassRoom: {
    /*
     * 列表（班级教学计划）
     */
    get: (p, c) =>
      $.get("/api/cms/resource/continueTeachingPlan/listForClassRoom", p, c),
  },
  continueTeachingPlan_listForClassRoomByDomain: {
    /*
     * 列表（班级教学计划）-根据学校域名
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/continueTeachingPlan/listForClassRoomByDomain",
        p,
        c
      ),
  },
  continueTeachingPlan_listForSite: {
    /*
     * 列表（学校教学计划）
     */
    get: (p, c) =>
      $.get("/api/cms/resource/continueTeachingPlan/listForSite", p, c),
  },
  continueTeachingPlan_listSimple: {
    /*
     * 简易列表（班主任）（班级）
     * classRoomId 班级id (integer query required)
     * term 学期 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/continueTeachingPlan/listSimple", p, c),
  },
  continueTeachingPlan_listSimpleForSiteByTeacher: {
    /*
     * 简易列表（教学计划）（讲师）
     * siteId 学校id (integer query required)
     * timeRange 时间 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/continueTeachingPlan/listSimpleForSiteByTeacher",
        p,
        c
      ),
  },
  continueTeachingPlan_listSimpleForTeacher: {
    /*
     * 简易列表（班级）
     * classRoomId 班级id (integer query required)
     * term 学期 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/continueTeachingPlan/listSimpleForTeacher",
        p,
        c
      ),
  },
  continueTeachingPlan_listSimpleSite: {
    /*
     * 简易列表（学校）
     * courseId 课程id (integer query required)
     * siteId 学校id (integer query required)
     * term 考期 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/continueTeachingPlan/listSimpleSite", p, c),
  },
  continueTeachingPlan_listSimpleSiteForTeacher: {
    /*
     * 简易列表（学校）
     * siteId 学校id (integer query required)
     * timeRange 时间 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/continueTeachingPlan/listSimpleSiteForTeacher",
        p,
        c
      ),
  },
  continueTeachingPlan_listSiteForSiteByTeacher: {
    /*
     * 简易列表（学校）（讲师）
     * teacherId 讲师id (integer query required)
     * timeRange 时间 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/continueTeachingPlan/listSiteForSiteByTeacher",
        p,
        c
      ),
  },
  continueTeachingPlan_listTeacher: {
    /*
     * 讲师列表表（班级）
     * classRoomId 班级id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/continueTeachingPlan/listTeacher", p, c),
  },
  continueTeachingPlan_listTerm: {
    /*
     * 学期列表表（班级）
     * classRoomId 班级id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/continueTeachingPlan/listTerm", p, c),
  },
  continueTeachingPlan_uploadForClassRoom: {
    /*
     * 导入（班级教学计划）
     * file file (file formData required)
     */
    post: (p, c) =>
      $.post("/api/cms/resource/continueTeachingPlan/uploadForClassRoom", p, c),
  },
  continueTeachingPlan_uploadForClassRoomByDomain: {
    /*
     * 导入（班级教学计划）
     * file file (file formData required)
     */
    post: (p, c) =>
      $.post(
        "/api/cms/resource/continueTeachingPlan/uploadForClassRoomByDomain",
        p,
        c
      ),
  },
  continueTeachingPlan_uploadForSite: {
    /*
     * 导入（学校教学计划）
     * file file (file formData required)
     */
    post: (p, c) =>
      $.post("/api/cms/resource/continueTeachingPlan/uploadForSite", p, c),
  },

  /**
   * 课程
   */
  course: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * code 课程代码 (string query )
     * content 课程内容 (string query )
     * cover 封面 (string query )
     * id  (integer query )
     * materialsUrl 讲义 (string query )
     * name 课程名字 (string query )
     * province 省份 (string query )
     * subtitle 副标题 (string query )
     * teacherAvatar 授课老师头像 (string query )
     * teacherName 授课老师 (string query )
     * teacherSummary 授课老师简介 (string query )
     * title 主标题 (string query )
     * type 类型：成教，成考，专升本 (string query )
     */
    post: (p, c) => $.post("/api/cms/resource/course", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/course", p, c),
  },
  course_details: {
    /*
     * 课程详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/course/details", p, c),
  },
  course_detailsAdultExamCourseForClient: {
    /*
     * C端成考课程详情
     * id 课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/course/detailsAdultExamCourseForClient", p, c),
  },
  course_getIdByName: {
    /*
     * 通过名字获取id
     * name 课程名字 (string query required)
     * province 省份-全部 (string query )
     * type 课程类型：成教，成考，继教院、技能培训 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/course/getIdByName", p, c),
  },
  course_listAdultEducationCourse: {
    /*
     * 成教课程列表
     */
    get: (p, c) =>
      $.get("/api/cms/resource/course/listAdultEducationCourse", p, c),
  },
  course_listAdultExamCourse: {
    /*
     * 成考课程列表
     */
    get: (p, c) => $.get("/api/cms/resource/course/listAdultExamCourse", p, c),
  },
  course_listAdultExamCourseForClient: {
    /*
     * C端成考课程列表
     */
    get: (p, c) =>
      $.get("/api/cms/resource/course/listAdultExamCourseForClient", p, c),
  },
  course_listContinueCourse: {
    /*
     * 继教院课程列表
     */
    get: (p, c) => $.get("/api/cms/resource/course/listContinueCourse", p, c),
  },
  course_listDiscipline: {
    /*
     * 科类列表
     * id id (integer query required)
     * level 层次 (string query )
     */
    get: (p, c) => $.get("/api/cms/resource/course/listDiscipline", p, c),
  },
  course_listSimpleAdultExamCourseForClient: {
    /*
     * C端简易成考课程列表
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/course/listSimpleAdultExamCourseForClient",
        p,
        c
      ),
  },
  course_listSimpleCourse: {
    /*
     * 简易课程列表
     * ableStatus 启用状态 (string query )
     * type 课程类型：成教，成考，继教院、技能培训 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/course/listSimpleCourse", p, c),
  },
  course_listSkillTrain: {
    /*
     * 课程列表-技能培训
     */
    get: (p, c) => $.get("/api/cms/resource/course/listSkillTrain", p, c),
  },
  course_listSkillTrainForClient: {
    /*
     * C端课程列表-技能培训
     */
    get: (p, c) =>
      $.get("/api/cms/resource/course/listSkillTrainForClient", p, c),
  },
  course_updateDiscipline: {
    /*
     * 编辑科类
     * disciplines 科类列表 (array query required)
     * id id (integer query required)
     * level 层次 (string query )
     */
    put: (p, c) => $.put("/api/cms/resource/course/updateDiscipline", p, c),
  },

  /**
   * 线下课表
   */
  courseTable: {
    /*
     * 添加
     * classRoomId 班级id (integer query )
     * courseDate 日期 (string query )
     * finishStatus 是否已上课 (string query )
     * id  (integer query )
     * planId 教学计划id (integer query )
     * saveType 添加类型：当前、全部 (string query )
     * schoolroomId 教室id (integer query )
     * templateId 模板id (integer query )
     * term 学期 (integer query )
     * type 类型：标准、实时 (string query )
     */
    post: (p, c) => $.post("/api/cms/resource/courseTable", p, c),

    /*
     * 删除
     * id id (integer query required)
     * type 类型：当前，全部 (string query )
     */
    delete: (p, c) => $.delete("/api/cms/resource/courseTable", p, c),
  },
  courseTable_confirm: {
    /*
     * 确认
     * classRoomId 班级id (integer query required)
     * term 学期 (integer query required)
     */
    post: (p, c) => $.post("/api/cms/resource/courseTable/confirm", p, c),
  },
  courseTable_finish: {
    /*
     * 完成上课
     * ids id (array query required)
     */
    put: (p, c) => $.put("/api/cms/resource/courseTable/finish", p, c),
  },
  courseTable_listDayForAttendanceByStudent: {
    /*
     * 天考勤课表(学生)
     * classRoomId 班级id (integer query )
     * courseDate 日期（当天0点） (string query required)
     * schoolRollId 学生id (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/courseTable/listDayForAttendanceByStudent",
        p,
        c
      ),
  },
  courseTable_listForTeacher: {
    /*
     * 实时课表列表（讲师）
     */
    get: (p, c) => $.get("/api/cms/resource/courseTable/listForTeacher", p, c),
  },
  courseTable_listSchoolroomInfo: {
    /*
     * 教室列表
     * classRoomId 班级id (integer query required)
     * endTime 结束时间 (string query required)
     * startTime 开始时间 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/courseTable/listSchoolroomInfo", p, c),
  },
  courseTable_listTeachingPlanInfo: {
    /*
     * 排课教学计划情况
     * classRoomId 班级id (integer query required)
     * term 学期 (integer query required)
     */
    post: (p, c) =>
      $.post("/api/cms/resource/courseTable/listTeachingPlanInfo", p, c),
  },
  courseTable_listTodayForAttendance: {
    /*
     * 当天考勤课表
     * classRoomId 班级id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/courseTable/listTodayForAttendance", p, c),
  },
  courseTable_listWeekForAttendanceByStudent: {
    /*
     * 周考勤课表(学生)
     * classRoomId 班级id (integer query )
     * endTime 结束时间：周日23点59分59秒 (string query required)
     * schoolRollId 学生id (integer query )
     * startTime 开始时间：周一0点 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/courseTable/listWeekForAttendanceByStudent",
        p,
        c
      ),
  },
  courseTable_tableInfo: {
    /*
     * 排课信息
     * classRoomId 班级id (integer query required)
     * end 结束时间，类型为实时的时候启用 (string query )
     * siteType 学校类型 (string query required)
     * start 开始时间，类型为实时的时候启用 (string query )
     * term 学期 (integer query required)
     * type 类型：标准，实时 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/courseTable/tableInfo", p, c),
  },
  courseTable_tableInfoForClient: {
    /*
     * C端排课信息（课表）
     * end 结束时间 (string query required)
     * start 开始时间 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/courseTable/tableInfoForClient", p, c),
  },
  courseTable_updateSchoolroom: {
    /*
     * 更新教室
     * id 课表id (integer query required)
     * schoolroomId 教室id (integer query required)
     * type 类型：全部、当前 (string query required)
     */
    put: (p, c) =>
      $.put("/api/cms/resource/courseTable/updateSchoolroom", p, c),
  },

  /**
   * 课表模板
   */
  courseTableTemplate: {
    /*
     * 添加
     * endTime.hour  (integer query )
     * endTime.minute  (integer query )
     * endTime.nano  (integer query )
     * endTime.second  (integer query )
     * id  (integer query )
     * name 模板名称 (string query )
     * startTime.hour  (integer query )
     * startTime.minute  (integer query )
     * startTime.nano  (integer query )
     * startTime.second  (integer query )
     * timeType 时间类型：上午、下午 (string query )
     * type 类型：继教院 (string query )
     * week 周几 (integer query )
     */
    post: (p, c) => $.post("/api/cms/resource/courseTableTemplate", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/courseTableTemplate", p, c),
  },
  courseTableTemplate_listByName: {
    /*
     * 课表列表
     * name 模板名字 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/courseTableTemplate/listByName", p, c),
  },
  courseTableTemplate_listForContinue: {
    /*
     * 继教院课表模板列表
     */
    get: (p, c) =>
      $.get("/api/cms/resource/courseTableTemplate/listForContinue", p, c),
  },
  courseTableTemplate_listForContinueByDomain: {
    /*
     * 继教院课表模板列表
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/courseTableTemplate/listForContinueByDomain",
        p,
        c
      ),
  },
  courseTableTemplate_listName: {
    /*
     * 模板名称列表
     * type 类型 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/courseTableTemplate/listName", p, c),
  },

  /**
   * 电子书
   */
  ebook: {
    /*
     * 添加编辑
     * ableStatus 启用状态 (string query )
     * cover 封面 (string query )
     * fileResourceId 资源文件ID (integer query )
     * id  (integer query )
     * intro 介绍 (string query )
     * name 电子书名称 (string query )
     * type 类型：成教，成考，专升本 (string query )
     */
    post: (p, c) => $.post("/api/cms/resource/ebook", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/ebook", p, c),
  },
  ebook_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/ebook/details", p, c),
  },
  ebook_exportForAdult: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/resource/ebook/exportForAdult", p, c),
  },
  ebook_listForAdult: {
    /*
     * 成教电子书列表
     */
    get: (p, c) => $.get("/api/cms/resource/ebook/listForAdult", p, c),
  },
  ebook_listSimple: {
    /*
     * 简易电子书列表
     * ableStatus 启用状态 (string query )
     * type 类型：成教 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/ebook/listSimple", p, c),
  },

  /**
   * 知识点
   */
  knowledge: {
    /*
     * 添加
     * ableStatus 启用，禁用 (string query )
     * canTry 是否可以试看 (string query )
     * courseId 课程id (integer query )
     * docUrl 文档地址 (string query )
     * duration 视频时长（秒） (integer query )
     * id  (integer query )
     * name 知识点（节名称） (string query )
     * section 大章名称 (string query )
     * sort 排序 (integer query )
     * type 类型（全部、视频、习题） (string query )
     * videoUrl 视频地址 (string query )
     */
    post: (p, c) => $.post("/api/cms/resource/knowledge", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/knowledge", p, c),
  },
  knowledge_batchAble: {
    /*
     * 批量启用禁用
     * ableStatus 启用状态：启用，禁用 (string query required)
     * ids 知识点id (array query required)
     */
    put: (p, c) => $.put("/api/cms/resource/knowledge/batchAble", p, c),
  },
  knowledge_batchRemove: {
    /*
     * 批量删除
     * ids 知识点id (array query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/knowledge/batchRemove", p, c),
  },
  knowledge_exportAdultEducationKnowledge: {
    /*
     * 批量导出成教知识点
     */
    get: (p, c) =>
      $.get("/api/cms/resource/knowledge/exportAdultEducationKnowledge", p, c),
  },
  knowledge_listAdultEducationKnowledge: {
    /*
     * 成教知识点列表
     */
    get: (p, c) =>
      $.get("/api/cms/resource/knowledge/listAdultEducationKnowledge", p, c),
  },
  knowledge_listAdultExamKnowledge: {
    /*
     * 成考知识点列表
     */
    get: (p, c) =>
      $.get("/api/cms/resource/knowledge/listAdultExamKnowledge", p, c),
  },
  knowledge_listForClient: {
    /*
     * C端章节列表
     * courseId 课程id (integer query required)
     * type 类型：全部、视频、习题 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/knowledge/listForClient", p, c),
  },
  knowledge_listSKillTrainSubject: {
    /*
     * 技能培训知识点列表-习题
     */
    get: (p, c) =>
      $.get("/api/cms/resource/knowledge/listSKillTrainSubject", p, c),
  },
  knowledge_listSKillTrainVideo: {
    /*
     * 技能培训知识点列表-视频
     */
    get: (p, c) =>
      $.get("/api/cms/resource/knowledge/listSKillTrainVideo", p, c),
  },
  knowledge_listSection: {
    /*
     * 简易大章列表
     * courseId 课程id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/knowledge/listSection", p, c),
  },
  knowledge_listSimple: {
    /*
     * 简易大章列表
     * courseId 课程id (integer query required)
     * section 大章名称 (string query )
     */
    get: (p, c) => $.get("/api/cms/resource/knowledge/listSimple", p, c),
  },
  knowledge_listStudentKnowledgeSectionForClient: {
    /*
     * 学生知识点大章列表
     * courseId 课程id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/knowledge/listStudentKnowledgeSectionForClient",
        p,
        c
      ),
  },

  /**
   * 学习资料
   */
  learningFile: {
    /*
     * 添加
     * courseId 课程id (integer query )
     * cover 封面 (string query )
     * id  (integer query )
     * payUrl 购买地址 (string query )
     * price 价格 (number query )
     * title 标题 (string query )
     * type 类型：成考通关资料 (string query )
     */
    post: (p, c) => $.post("/api/cms/resource/learningFile", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/learningFile", p, c),
  },
  learningFile_listAdultExamLearningFile: {
    /*
     * 成考通关资料列表
     */
    get: (p, c) =>
      $.get("/api/cms/resource/learningFile/listAdultExamLearningFile", p, c),
  },
  learningFile_listLearningFileForClient: {
    /*
     * 学习资料列表
     * type 资料类型：成考通关资料 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/learningFile/listLearningFileForClient", p, c),
  },

  /**
   * 成考直播课
   */
  liveCourse: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * courseId 课程id (integer query )
     * cover 封面 (string query )
     * homeShow 是否主页展示 (string query )
     * id  (integer query )
     * note 注意事项 (string query )
     * teacher 老师 (string query )
     * teacherAvatar 老师头像 (string query )
     * teacherSummary 老师简介 (string query )
     * title 标题 (string query )
     * type 类型：公开课等等 (string query )
     */
    post: (p, c) => $.post("/api/cms/resource/liveCourse", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/liveCourse", p, c),
  },
  liveCourse_detailsAdultExamLiveCourseForClient: {
    /*
     * C端成考课程详情
     * id 直播课程id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/liveCourse/detailsAdultExamLiveCourseForClient",
        p,
        c
      ),
  },
  liveCourse_listAdultExamLiveCourse: {
    /*
     * 成考直播课程列表
     */
    get: (p, c) =>
      $.get("/api/cms/resource/liveCourse/listAdultExamLiveCourse", p, c),
  },
  liveCourse_listAdultExamLiveCourseForClient: {
    /*
     * C端成考直播课程列表
     * type 类别：公开课 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/liveCourse/listAdultExamLiveCourseForClient",
        p,
        c
      ),
  },
  liveCourse_listAdultExamLiveCoursePlaybackForClient: {
    /*
     * 根据课程id获取成考直播课程
     * type 类别：公开课 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/liveCourse/listAdultExamLiveCoursePlaybackForClient",
        p,
        c
      ),
  },
  liveCourse_listSimple: {
    /*
     * 直播课简易列表
     * courseType 课程类别 (string query required)
     * liveCourseType 类别：公开课 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/liveCourse/listSimple", p, c),
  },

  /**
   * 成考直播章节
   */
  liveCourseChapter: {
    /*
     * 添加
     * docUrl 文档地址 (string query )
     * duration 视频时长（秒） (integer query )
     * endLive 结束直播时间 (string query )
     * id  (integer query )
     * liveCourseId 直播课id (integer query )
     * name 章节名 (string query )
     * section 大章名称 (string query )
     * sort 排序 (integer query )
     * startLive 开始直播时间 (string query )
     * videoUrl 视频地址 (string query )
     */
    post: (p, c) => $.post("/api/cms/resource/liveCourseChapter", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/liveCourseChapter", p, c),
  },
  liveCourseChapter_listAdultExamLiveCourseChapter: {
    /*
     * 成考直播章节列表
     */
    get: (p, c) =>
      $.get(
        "/api/cms/resource/liveCourseChapter/listAdultExamLiveCourseChapter",
        p,
        c
      ),
  },
  liveCourseChapter_listPassedForClient: {
    /*
     * 回放列表（需要登录）
     * liveCourseId 直播课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/liveCourseChapter/listPassedForClient", p, c),
  },
  liveCourseChapter_listSection: {
    /*
     * 简易大章列表
     * liveCourseId 直播课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/liveCourseChapter/listSection", p, c),
  },
  liveCourseChapter_listSimple: {
    /*
     * 简易列表
     * liveCourseId 直播课程id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/liveCourseChapter/listSimple", p, c),
  },

  /**
   * 试卷
   */
  paper: {
    /*
     * 添加
     * ableStatus 启用状态 (string query )
     * attach 试卷附件 (string query )
     * courseId 课程id (integer query )
     * duration 建议答题时长 (string query )
     * endTime 结束时间 (string query )
     * id  (integer query )
     * name 名字 (string query )
     * scoreStatus 成绩发布状态：未发布，已发布 (string query )
     * startTime 开始时间 (string query )
     * type 试卷类型:历年真题，模拟测试，摸底考试 (string query )
     * userId 用户id (integer query )
     * year 成考年度,摸底考试用 (string query )
     */
    post: (p, c) => $.post("/api/cms/resource/paper", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/paper", p, c),
  },
  paper_exportAdultExamStudentTestPaper: {
    /*
     * 导出-学历教育-成考管理-成考摸底详情
     */
    get: (p, c) =>
      $.get("/api/cms/resource/paper/exportAdultExamStudentTestPaper", p, c),
  },
  paper_listAdultExamStudentTestPaper: {
    /*
     * 列表-学历教育-成考管理-成考摸底详情
     */
    get: (p, c) =>
      $.get("/api/cms/resource/paper/listAdultExamStudentTestPaper", p, c),
  },
  paper_listHabitTestPaper: {
    /*
     * 摸底考试列表
     */
    get: (p, c) => $.get("/api/cms/resource/paper/listHabitTestPaper", p, c),
  },
  paper_listMockTestPaper: {
    /*
     * 模拟测试列表
     */
    get: (p, c) => $.get("/api/cms/resource/paper/listMockTestPaper", p, c),
  },
  paper_listName: {
    /*
     * 试卷名称列表
     * courseId 课程id (integer query required)
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/paper/listName", p, c),
  },
  paper_listPaper: {
    /*
     * 试卷(历年真题和模拟测试)列表
     * courseId 课程id (integer query required)
     * type 试卷类型：历年真题，模拟测试，摸底考试，社会生摸底考试 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/paper/listPaper", p, c),
  },
  paper_listPaperForClient: {
    /*
     * C端试卷(历年真题,模拟测试,摸底考试，社会生摸底考试，顺序练习)列表
     * courseId 课程id (integer query )
     * type 试卷类型：历年真题，模拟测试，顺序练习 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/paper/listPaperForClient", p, c),
  },
  paper_listPaperForMainPage: {
    /*
     * 首页试卷(历年真题,模拟测试,摸底考试)列表
     * type 试卷类型：历年真题，模拟测试，摸底考试 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/paper/listPaperForMainPage", p, c),
  },
  paper_listPastRealPaper: {
    /*
     * 历年真题列表
     */
    get: (p, c) => $.get("/api/cms/resource/paper/listPastRealPaper", p, c),
  },
  paper_listSimple: {
    /*
     * 试卷简易列表
     * courseId 课程id (integer query required)
     * type 试卷类型：历年真题，模拟测试，摸底考试 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/paper/listSimple", p, c),
  },
  paper_listSkillTrainMockPaper: {
    /*
     * 模拟测试列表-技能培训
     */
    get: (p, c) =>
      $.get("/api/cms/resource/paper/listSkillTrainMockPaper", p, c),
  },
  paper_listStudentTestPaperDetail: {
    /*
     * 具体成绩列表-学历教育-成考管理-成考摸底详情
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/paper/listStudentTestPaperDetail", p, c),
  },
  paper_testPaperForClient: {
    /*
     * C端试卷(摸底考试)
     */
    get: (p, c) => $.get("/api/cms/resource/paper/testPaperForClient", p, c),
  },
  paper_uploadSortSubject: {
    /*
     * 上传顺序练习习题
     * courseId 课程id (integer query required)
     * file file (file formData required)
     * paperName 顺序练习试卷名称 (string query required)
     */
    post: (p, c) => $.post("/api/cms/resource/paper/uploadSortSubject", p, c),
  },
  paper_uploadSortSubjectByExcel: {
    /*
     * 上传顺序练习习题-Excel模式
     * courseId 课程id (integer query required)
     * file file (file formData required)
     * paperName 顺序练习试卷名称 (string query required)
     */
    post: (p, c) =>
      $.post("/api/cms/resource/paper/uploadSortSubjectByExcel", p, c),
  },
  paper_uploadSubject: {
    /*
     * 上传试卷习题
     * attach 附件地址 (string query required)
     * file file (file formData required)
     * id 试卷id (integer query required)
     */
    post: (p, c) => $.post("/api/cms/resource/paper/uploadSubject", p, c),
  },
  paper_uploadSubjectByExcel: {
    /*
     * 上传试卷习题-Excel模式
     * attachUrl 试卷源文件地址 (string query required)
     * excelFile excelFile (file formData required)
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/cms/resource/paper/uploadSubjectByExcel", p, c),
  },

  /**
   * 教室
   */
  schoolroom: {
    /*
     * 添加
     * id  (integer query )
     * name 教室名称 (string query )
     * region 区域 (string query )
     * siteId 学校id (integer query )
     */
    post: (p, c) => $.post("/api/cms/resource/schoolroom", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/schoolroom", p, c),
  },
  schoolroom_exportForContinue: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/cms/resource/schoolroom/exportForContinue", p, c),
  },
  schoolroom_listForContinue: {
    /*
     * 继教院教室列表
     */
    get: (p, c) => $.get("/api/cms/resource/schoolroom/listForContinue", p, c),
  },
  schoolroom_listRegin: {
    /*
     * 区域列表
     * siteId 学校id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/schoolroom/listRegin", p, c),
  },
  schoolroom_listSimple: {
    /*
     * 教室简易列表
     * siteId 学校id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/schoolroom/listSimple", p, c),
  },
  schoolroom_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     * siteId 学校id (integer query required)
     */
    post: (p, c) => $.post("/api/cms/resource/schoolroom/upload", p, c),
  },

  /**
   * 自考试卷配置
   */
  selfPaperConfig_getConfig: {
    /*
     * 获取配置
     * courseId 课程id (integer query required)
     * type 试卷类型：模拟考试 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/selfPaperConfig/getConfig", p, c),
  },
  selfPaperConfig_setConfig: {
    /*
     * 设置配置
     * content 配置的json字符串 (string query required)
     * courseId 课程id (integer query required)
     * type 试卷类型：模拟考试 (string query required)
     */
    post: (p, c) => $.post("/api/cms/resource/selfPaperConfig/setConfig", p, c),
  },

  /**
   * 学校教学名单
   */
  sitePlanRoster: {
    /*
     * 添加
     * attendanceStatus 是否打卡 (string query required)
     * planId 教学计划id (integer query required)
     * schoolRollIds 合同id (array query required)
     */
    post: (p, c) => $.post("/api/cms/resource/sitePlanRoster", p, c),

    /*
     * 删除
     * planId 教学计划id (integer query required)
     * schoolRollIds 合同id (array query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/sitePlanRoster", p, c),
  },
  sitePlanRoster_addToApp: {
    /*
     * 将未通过学生名单加入名称为自考app使用的教学计划（当前考期）
     * courseId 课程id (integer query required)
     * majorCourseId 专业课程 (integer query required)
     * siteId 学校id (integer query required)
     */
    post: (p, c) => $.post("/api/cms/resource/sitePlanRoster/addToApp", p, c),
  },
  sitePlanRoster_export: {
    /*
     * 简易列表导出
     * classRoomId 班级id (integer query )
     * planId 教学计划id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/sitePlanRoster/export", p, c),
  },
  sitePlanRoster_exportUnPassedStudent: {
    /*
     * 未通过学生列表导出
     * majorCourseId 专业id (integer query required)
     * siteId 学校id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/sitePlanRoster/exportUnPassedStudent", p, c),
  },
  sitePlanRoster_list: {
    /*
     * 简易列表
     * classRoomId 班级id (integer query )
     * planId 教学计划id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/sitePlanRoster/list", p, c),
  },
  sitePlanRoster_listByStudent: {
    /*
     * 根据学生获取教学计划
     * schoolRollId 合同id (integer query required)
     * term 考期 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/sitePlanRoster/listByStudent", p, c),
  },
  sitePlanRoster_listUnJoined: {
    /*
     * 未添加进教学计划的名单简易列表
     * classRoomId 班级id (integer query )
     * planId 教学计划id (integer query required)
     * siteId 学校id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/sitePlanRoster/listUnJoined", p, c),
  },
  sitePlanRoster_upload: {
    /*
     * 导入（覆盖模式）
     * classRoomId 班级id (integer query )
     * file 文件 (file formData required)
     * planId 教学计划id (integer query required)
     * type 合同类型:自考，继教院 (string query required)
     */
    post: (p, c) => $.post("/api/cms/resource/sitePlanRoster/upload", p, c),
  },

  /**
   * 学校课表
   */
  siteTable: {
    /*
     * 添加
     * id  (integer query )
     * siteId 学校id (integer query )
     * status 状态 (string query )
     * tableTemplate 课表模板 (string query )
     * teacherId 讲师id (integer query )
     * timeRange 课表时间 (string query )
     */
    post: (p, c) => $.post("/api/cms/resource/siteTable", p, c),
  },
  siteTable_clear: {
    /*
     * 清除实时课表
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/siteTable/clear", p, c),
  },
  siteTable_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/resource/siteTable/list", p, c),
  },

  /**
   * 学校课表项
   */
  siteTableItem: {
    /*
     * 添加
     * courseDate 日期 (string query )
     * finishStatus 是否已完成授课 (string query )
     * id  (integer query )
     * planId 教学计划id (integer query )
     * saveType 添加类型：当前、全部 (string query )
     * schoolroomId 教室id (integer query )
     * siteId 学校id (integer query )
     * teacherId 老师id (integer query )
     * templateId 模板id (integer query )
     * timeRange 课表时间 (string query )
     * type 类型：标准、实时 (string query )
     */
    post: (p, c) => $.post("/api/cms/resource/siteTableItem", p, c),

    /*
     * 删除
     * id id (integer query required)
     * removeType 删除类型：当前，全部 (string query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/siteTableItem", p, c),
  },
  siteTableItem_confirm: {
    /*
     * 确认
     * siteId 学校id (integer query required)
     * teacherId 老师id (integer query required)
     * timeRange 时间 (string query required)
     */
    post: (p, c) => $.post("/api/cms/resource/siteTableItem/confirm", p, c),
  },
  siteTableItem_getStudentTableItem: {
    /*
     * 获取学生课表(班主任视图)
     * attendanceDate 考勤日期 (string query required)
     * classRoomId 班级id (integer query )
     * siteId 学校id (integer query required)
     * timeType 时间类型：上午、下午、晚上 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/siteTableItem/getStudentTableItem", p, c),
  },
  siteTableItem_listSimpleForTeacher: {
    /*
     * 获取学校-教学计划简易列表
     * attendanceDate 考勤日期 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/siteTableItem/listSimpleForTeacher", p, c),
  },
  siteTableItem_tableInfo: {
    /*
     * 排课信息
     * end 结束时间，类型为实时的时候启用 (string query )
     * siteId 学校id (integer query required)
     * start 开始时间，类型为实时的时候启用 (string query )
     * teacherId 老师id (integer query required)
     * timeRange 时间 (string query required)
     * type 类型：标准，实时 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/siteTableItem/tableInfo", p, c),
  },
  siteTableItem_updateSchoolroom: {
    /*
     * 更新教室
     * id 课表id (integer query required)
     * schoolroomId 教室id (integer query required)
     * updateType 类型：全部、当前 (string query required)
     */
    put: (p, c) =>
      $.put("/api/cms/resource/siteTableItem/updateSchoolroom", p, c),
  },

  /**
   * 学生试卷
   */
  studentPaper_createPaper: {
    /*
     * 创建试卷
     * contentNum 由题干文章数量 (integer query required)
     * noContentNum 无题干题目数量 (integer query required)
     * paperId 顺序练习习题类型id (integer query required)
     */
    post: (p, c) => $.post("/api/cms/resource/studentPaper/createPaper", p, c),
  },
  studentPaper_listForClient: {
    /*
     * 试卷列表
     * paperId 顺序练习习题类型id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/studentPaper/listForClient", p, c),
  },

  /**
   * 习题
   */
  subject: {
    /*
     * 添加
     * ableStatus 启用状态：启用，禁用 (string query )
     * analysis 解析 (string query )
     * answer 正确答案 (string query )
     * answerA 答案A (string query )
     * answerB 答案B (string query )
     * answerC 答案C (string query )
     * answerD 答案D (string query )
     * answerE 答案E (string query )
     * answerF 答案F (string query )
     * answerG 答案G (string query )
     * answerH 答案H (string query )
     * answerI 答案I (string query )
     * belongId 归属id,如果是章节练习，则为知识点id,其他为试卷id (integer query )
     * content 题目 (string query )
     * contentId 内容id (integer query )
     * contentType 内容类型：单选，多选，判断等 (string query )
     * id  (integer query )
     * level 难度:简单,一般,难 (string query )
     * logicType 逻辑类型：单选，多选，判断，填空 (string query )
     * originId 原习题id，顺序练习特有 (integer query )
     * remark 备注 (string query )
     * score 分值 (number query )
     * sort 习题序号，针对同一个contentId的习题，入股contentId为0，则序号也为0 (integer query )
     * type 习题类型：章节练习，直播课课后练习，模拟测试，历年真题，摸底考试，社会生摸底考试，顺序练习 (string query )
     */
    post: (p, c) => $.post("/api/cms/resource/subject", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/subject", p, c),
  },
  subject_clearByBelongId: {
    /*
     * 根据归属id清除
     * belongId 归属id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/cms/resource/subject/clearByBelongId", p, c),
  },
  subject_countSortSubject: {
    /*
     * 顺序练习习题数量
     * paperId 顺序练习试卷id (integer query required)
     * type 类型： 有内容、无内容 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/subject/countSortSubject", p, c),
  },
  subject_detailChapterSubject: {
    /*
     * 章节习题详情
     * id 习题id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/subject/detailChapterSubject", p, c),
  },
  subject_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/subject/details", p, c),
  },
  subject_detailsByPaperForClient: {
    /*
     * C端试卷习题详情
     * exerciseId 练习id,解析的时候一定要传 (integer query )
     * paperId 试卷id (integer query required)
     * type 类型：测试，考试，解析 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/subject/detailsByPaperForClient", p, c),
  },
  subject_detailsByPaperId: {
    /*
     * 试卷习题详情
     * exerciseId 练习id (integer query )
     * paperId 试卷id (integer query required)
     * userId 用户id (integer query )
     */
    get: (p, c) => $.get("/api/cms/resource/subject/detailsByPaperId", p, c),
  },
  subject_downloadExcelModule: {
    /*
     * 下载Excel习题模版
     */
    get: (p, c) => $.get("/api/cms/resource/subject/downloadExcelModule", p, c),
  },
  subject_downloadMouldExcelSubject: {
    /*
     * 下载Excel习题模版
     */
    get: (p, c) =>
      $.get("/api/cms/resource/subject/downloadMouldExcelSubject", p, c),
  },
  subject_exportSortSubject: {
    /*
     * 导出顺序联系习题列表
     */
    get: (p, c) => $.get("/api/cms/resource/subject/exportSortSubject", p, c),
  },
  subject_getContentByContentId: {
    /*
     * 根据内容id获取内容
     * id 内容id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/subject/getContentByContentId", p, c),
  },
  subject_getOrderSubjectForClient: {
    /*
     * 获取顺序习题
     * exerciseId 练习id,解析的时候一定要传 (integer query )
     * id 习题id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/subject/getOrderSubjectForClient", p, c),
  },
  subject_list: {
    /*
     * 章节练习习题列表
     * knowledgeId 知识点id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/subject/list", p, c),
  },
  subject_listByBelongId: {
    /*
     * 根据归属id获取习题列表
     * belongId 归属id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/resource/subject/listByBelongId", p, c),
  },
  subject_listCardSubjectForClient: {
    /*
     * 答题卡习题列表
     * exerciseId 练习id,解析的时候一定要传 (integer query )
     * paperId 试卷id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/resource/subject/listCardSubjectForClient", p, c),
  },
  subject_listSortSubject: {
    /*
     * 顺序练习习题列表
     */
    get: (p, c) => $.get("/api/cms/resource/subject/listSortSubject", p, c),
  },
  subject_refreshOrderSubject: {
    /*
     * 刷新顺序练习
     */
    post: (p, c) =>
      $.post("/api/cms/resource/subject/refreshOrderSubject", p, c),
  },
  subject_sortOrderSubject: {
    /*
     * 顺序练习重新排序
     */
    post: (p, c) => $.post("/api/cms/resource/subject/sortOrderSubject", p, c),
  },
  subject_updateChapterSubject: {
    /*
     * 编辑章节习题
     * ableStatus 启用状态|全部||字符串下拉|api/bms/develop/config/listSelect?key=启用状态 (string query )
     * analysis 解析|列表||| (string query )
     * answer 正确答案|列表||| (string query )
     * answerA 答案A|列表||| (string query )
     * answerB 答案B|列表||| (string query )
     * answerC 答案C|列表||| (string query )
     * answerD 答案D|列表||| (string query )
     * answerE 答案E|列表||| (string query )
     * answerF 答案F|列表||| (string query )
     * answerG 答案G|列表||| (string query )
     * answerH 答案H|列表||| (string query )
     * answerI 答案I|列表||| (string query )
     * content 题目|列表||| (string query )
     * contentContent 内容|列表||| (string query )
     * contentId 内容id|无||| (integer query )
     * contentType 内容类型|列表||| (string query )
     * id 习题id|无||| (integer query )
     * level 难度|列表||| (string query )
     * logicType 逻辑类型|全部||字符串下拉|api/bms/develop/config/listSelect?key=逻辑题型 (string query )
     * remark 备注|全部||| (string query )
     * sort 习题序号|列表||| (integer query )
     */
    put: (p, c) =>
      $.put("/api/cms/resource/subject/updateChapterSubject", p, c),
  },
  subject_uploadByExcel: {
    /*
     * 上传习题-Excel
     * belongId 归属id (integer query required)
     * file file (file formData required)
     * type 类型：章节练习，历年真题、摸底考试、模拟测试、全真模拟 (string query required)
     */
    post: (p, c) => $.post("/api/cms/resource/subject/uploadByExcel", p, c),
  },
  subject_uploadByWord: {
    /*
     * 上传习题-Word
     * belongId 归属id (integer query required)
     * file file (file formData required)
     * type 类型：章节练习，历年真题、摸底考试、模拟测试、全真模拟 (string query required)
     */
    post: (p, c) => $.post("/api/cms/resource/subject/uploadByWord", p, c),
  },
  subject_uploadChapterSubject: {
    /*
     * 上传章节习题-(Word)
     * belongId 知识点id (integer query required)
     * file file (file formData required)
     * type 类型：章节练习，直播课课后练习 (string query required)
     */
    post: (p, c) =>
      $.post("/api/cms/resource/subject/uploadChapterSubject", p, c),
  },
  subject_uploadSubjectByExcel: {
    /*
     * 上传习题
     * belongId 知识点id (integer query required)
     * file file (file formData required)
     * type 类型：章节练习，全真模拟 (string query required)
     */
    post: (p, c) =>
      $.post("/api/cms/resource/subject/uploadSubjectByExcel", p, c),
  },

  /**
   * 授课老师
   */
  teacher: {
    /*
     * 添加
     * adminId 管理员id (integer query )
     * id  (integer query )
     * name 名字 (string query )
     * type 类型：继教院 (string query )
     */
    post: (p, c) => $.post("/api/cms/resource/teacher", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/resource/teacher", p, c),
  },
  teacher_getCurrentTeacherId: {
    /*
     * 获取当前登录用户的授课老师id
     */
    get: (p, c) => $.get("/api/cms/resource/teacher/getCurrentTeacherId", p, c),
  },
  teacher_listForContinue: {
    /*
     * 继教院授课老师列表
     */
    get: (p, c) => $.get("/api/cms/resource/teacher/listForContinue", p, c),
  },
  teacher_listSimple: {
    /*
     * 简易列表
     * type 课程类型：继教院 (string query required)
     */
    get: (p, c) => $.get("/api/cms/resource/teacher/listSimple", p, c),
  },
  teacher_syncAdminInfo: {
    /*
     * 同步管理员信息
     */
    put: (p, c) => $.put("/api/cms/resource/teacher/syncAdminInfo", p, c),
  },
};
